import { IPhotoSectionPhoto } from './types';
import PhotoPlaceholderIcon from '@/assets/icons/photo-placeholder.svg?react';
import styles from './PhotoCaptureSection.module.scss';

interface IPhotoThumbnailCardProps {
  photo: IPhotoSectionPhoto;
  /* eslint-disable no-unused-vars */
  onClick: (photo: IPhotoSectionPhoto) => void;
  /* eslint-enable no-unused-vars */
  reserveTitleSpace: boolean;
  placeholderIconClassName?: string;
  title?: string;
}

function PhotoThumbnailCard({ photo, onClick, placeholderIconClassName = '', reserveTitleSpace, title }: IPhotoThumbnailCardProps) {
  const showTitle = Boolean(title);
  const showTitleRow = showTitle || reserveTitleSpace;
  const showPhoto = !photo.isPlaceholder;
  const showPlaceholder = Boolean(photo.isPlaceholder);
  const showUploadOverlay = photo.uploadStatus === 'processing';
  const showUploadError = photo.uploadStatus === 'error';
  let actionLabel = `View ${photo.name}`;
  let titleClassName = styles.photoTypeTitle;

  if (photo.isPlaceholder) {
    actionLabel = `Add ${photo.name} photo`;
  }

  if (!showTitle) {
    titleClassName = `${styles.photoTypeTitle} ${styles.emptyPhotoTypeTitle}`;
  }

  return (
    <div className={styles.photoCard}>
      {showTitleRow && <div className={titleClassName}>{title}</div>}
      <button type="button" className={styles.photoThumbnail} onClick={() => onClick(photo)} aria-label={actionLabel}>
        {showPhoto && <img src={photo.src} alt={photo.name} />}
        {showPlaceholder && <PhotoPlaceholderIcon className={placeholderIconClassName} aria-hidden="true" />}
        {showUploadOverlay && <span className={styles.uploadOverlay}>Uploading...</span>}
        {showUploadError && <span className={`${styles.uploadOverlay} ${styles.uploadError}`}>Upload failed</span>}
      </button>
      <div className={styles.photoCaption}>{photo.caption}</div>
    </div>
  );
}

export default PhotoThumbnailCard;
